import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);

export default function isBetweenHours(startHour: number, endHour: number) {
  // Only checks for London time, not Local time, nor UTC
  // E.G. 7AM UTC will be between 8 and 18 BST
  const fromTime = dayjs()
    .tz('Europe/London')
    .hour(startHour)
    .minute(0)
    .second(0);
  const toTime = dayjs().tz('Europe/London').hour(endHour).minute(0).second(0);

  return dayjs().isBetween(fromTime, toTime);
}
